import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { register as registerSW } from "@/serviceWorkerRegistration";

// Hors-ligne : les pages non offline-first font des appels réseau qui rejettent ("Network Error").
// On neutralise UNIQUEMENT ces rejets réseau (capture + stopImmediatePropagation) pour éviter
// l'écran d'erreur — les vraies erreurs applicatives restent visibles.
const isNetworkError = (r) =>
  !!r && (r.code === "ERR_NETWORK" || r.message === "Network Error" || (r.isAxiosError && !r.response));
window.addEventListener("unhandledrejection", (e) => {
  if (isNetworkError(e && e.reason)) {
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }
}, true);
window.addEventListener("error", (e) => {
  if (e && e.error && isNetworkError(e.error)) {
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

registerSW();
